import { marker as extractTranslation } from '@colsen1991/ngx-translate-extract-marker';
import { HttpErrorResponse } from '@angular/common/http';

export const INCORRECT_IDENTITY_ROLE_ERROR = {
  code: 'incorrect_identity_role',
} as const;

export interface CustomError {
  code?: (typeof INCORRECT_IDENTITY_ROLE_ERROR)['code'];
}

export interface ErrorMessage {
  title: string;
  text: string;
}

const ERROR_STATUSES = [-1, 400, 401, 403, 404, 500] as const;

export type ErrorStatus = (typeof ERROR_STATUSES)[number];

export const ERROR_MESSAGE_DICTIONARY: Record<ErrorStatus, ErrorMessage> = {
  '-1': {
    title: extractTranslation('common.errors.unknown.title'),
    text: extractTranslation('common.errors.unknown.text'),
  },
  400: {
    title: extractTranslation('common.errors.bad_request.title'),
    text: extractTranslation('common.errors.bad_request.text'),
  },
  401: {
    title: '',
    text: '',
  },
  403: {
    title: extractTranslation('common.errors.forbidden.title'),
    text: extractTranslation('common.errors.forbidden.text'),
  },
  404: {
    title: extractTranslation('common.errors.not_found.title'),
    text: extractTranslation('common.errors.not_found.text'),
  },
  500: {
    title: extractTranslation('common.errors.internal_server_error.title'),
    text: extractTranslation('common.errors.internal_server_error.text'),
  },
};

export const EXTERNAL_SERVICE_ERROR_MESSAGE: ErrorMessage = {
  title: extractTranslation('common.errors.external_service_error.title'),
  text: extractTranslation('common.errors.external_service_error.message'),
};

export const UNKNOWN_ERROR_MESSAGE: ErrorMessage = {
  title: extractTranslation('common.errors.unknown.title'),
  text: extractTranslation('common.errors.unknown.message'),
};

export const INCORRECT_IDENTITY_ROLE_ERROR_MESSAGE: ErrorMessage = {
  title: extractTranslation('screening.screening_overrides.incorrect_identity_role.title'),
  text: extractTranslation('screening.screening_overrides.incorrect_identity_role.message'),
};

export function isHttpErrorResponse(item: unknown): item is HttpErrorResponse {
  return (
    !!item &&
    typeof item === 'object' &&
    (item as HttpErrorResponse).name === 'HttpErrorResponse' &&
    item.hasOwnProperty('status') &&
    item.hasOwnProperty('message')
  );
}
